import { string } from 'prop-types';
import { Link, useRouteLoaderData } from 'react-router-dom';

/**
 * Render the company name
 * @param {object} root0 The props of the component.
 * @param {string} root0.id The id of the company.
 * @returns {JSX.Element} The rendered company name.
 */
const RenderCompanyName = ({ id }) => {
  const { data } = useRouteLoaderData('companies-crud');
  return (
    <Link to={`/app/company-management/view/${id}`}>
      {data?.company?.name ?? 'loading'}{' '}
    </Link>
  );
};

RenderCompanyName.propTypes = {
  id: string.isRequired,
};

export default RenderCompanyName;
